<template>
  <unicom-linha class="linha-embaixo">
    <unicom-coluna sm="2" :class="espacamentoMobile">
      <div align="right">Agência Transfusional</div>
    </unicom-coluna>

    <unicom-coluna sm="1" :class="espacamentoMobile">
      <unicom-switch :value="clickSwitch" @input="toggleSwitch" />
    </unicom-coluna>

    <unicom-coluna sm="6" :class="espacamentoMobile"></unicom-coluna>

    <!-- <unicom-coluna sm="3" :class="espacamentoMobile">
      <single-select
        @input="atualizarServicoPublico"
        :propsSingleSelect="{
          placeholder: 'Público',
          options: listaPublicoAlvo,
          'track-by': 'id',
          label: 'tipoServicoPublico'
        }"
        :value="payload.tipoServicoPublico"
        v-show="clickSwitch"
      />
    </unicom-coluna> -->
  </unicom-linha>
</template>

<script>
// import SingleSelect from "@/views/RecursosPropriosQuestionarios/shared/Singleselect.vue";

import SharedMixin from "./SharedMixin.js";

export default {
  mixins: [SharedMixin],
  components: {
    // SingleSelect
  },
  data() {
    return {
      payload: {
        tipoServico: "Agência Transfusional",
        tipoServicoPublico: []
      }
    };
  },
  methods: {},
  watch: {
    dadosServidor(newVal) {
      if (newVal.servicos.length < 1) return;
      newVal.servicos.forEach(servico => {
        if (servico.tipoServico.tipoServico.includes("Agência Transfusional")) {
          this.clickSwitch = true;
          this.emitPayload({
            ...this.payload,
            clickSwitch: this.clickSwitch
          });
        }
      });
    }
  }
};
</script>
